export enum EnumTargetDistributorStatus {
  ACTIVE = 'ACTIVE',
  SCHEDULED = 'SCHEDULED',
  FINISHED = 'FINISHED',
  SUBMITTED = 'SUBMITTED',
  NEED_CHANGED = 'NEED_CHANGED',
  EXTENDED_PERIOD = 'EXTENDED_PERIOD',
}

export enum EnumTargetDistributorStatusString {
  ACTIVE = 'Aktif',
  SUBMITTED = 'Diajukan',
  SCHEDULED = 'Dijadwalkan',
  FINISHED = 'Selesai',
  NEED_CHANGED = 'Butuh Perbaikan',
  EXTENDED_PERIOD = 'Pengajuan Perpanjangan',
}

export enum EnumScopeType {
  NATIONAL = 'NATIONAL',
  AREA = 'AREA',
  DISTRIBUTOR = 'DISTRIBUTOR',
}

export enum EnumTargetType {
  NOMINAL = 'NOMINAL',
  WEIGHT_UNIT = 'WEIGHT_UNIT',
  SALE_UNIT = 'SALE_UNIT',
}

export enum EnumTargetProductEnum {
  ALL_PRODUCT = 'ALL_PRODUCT',
  SPECIFIC_PRODUCT = 'SPECIFIC_PRODUCT',
}

export enum EnumTargetCalculationSpec {
  ACCUMULATION = 'ACCUMULATION',
  BUNDLING = 'BUNDLING',
}

export enum EnumRewardType {
  INCENTIVE = 'INCENTIVE',
  OTHER = 'OTHER',
}

export enum EnumIncentiveType {
  PERCENTAGE = 'PERCENTAGE',
  NOMINAL = 'NOMINAL',
}

export enum EnumAturanHadiah {
  BERLAKU_KELIPATAN = 'BERLAKU_KELIPATAN',
  TIDAK_BERLAKU_KELIPATAN = 'TIDAK_BERLAKU_KELIPATAN',
}

export enum EnumOpsiHadiahProgram {
  DAPAT_DIKLAIM_BERSAMAAN = 'DAPAT_DIKLAIM_BERSAMAAN',
  TIDAK_DAPAT_DIKLAIM_BERSAMAAN = 'TIDAK_DAPAT_DIKLAIM_BERSAMAAN',
}

export enum EnumSectionProgramTargetDistributor {
  DISCOUNT_TERM = 'DISCOUNT_TERM',
  SCOPE_TARGET = 'SCOPE_TARGET',
  TARGET_REWARD_TERM = 'TARGET_REWARD_TERM',
  OTHER_TERM = 'OTHER_TERM',
  OVERLAP_TERM = 'OVERLAP_TERM',
  INFORMATION = 'INFORMATION',
}

/**
 * Filter "Progres Distributor" pada tab Monitoring Program.
 *
 * IN_PROGRESS = "Sedang Berjalan"      -> belum mendapat hadiah sama sekali.
 * DONE        = "Menyelesaikan Target" -> sudah mendapat hadiah minimal satu tingkat.
 *
 * Catatan: distributor yang sedang berjalan di tingkat 2 tetapi sudah mendapat hadiah
 * tingkat 1 termasuk DONE, jadi tidak muncul saat filter "Sedang Berjalan".
 */
export enum EnumTargetDistributorProgressType {
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
}
